import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import './index.scss';
import rootReducer from './reducers';
import { Provider } from 'react-redux';
import * as Sentry from "@sentry/react";
import { createStore } from 'redux';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './language/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// if (!window.location.hostname.includes('localhost')) {
//   Sentry.init({
//     dsn: "https://407c18e6ce738890540ed3d79df88975@o4508595976863744.ingest.us.sentry.io/4508595980337152",
//     integrations: [
//       Sentry.browserTracingIntegration(),
//       Sentry.replayIntegration(),
//     ],
//     tracesSampleRate: 1.0,
//     tracePropagationTargets: [
//         "localhost", 
//         /^https:\/\/api\.cheongdamsecret\.com\/.*/
//     ],
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//   });
// }

const queryClient = new QueryClient();
const store = createStore(rootReducer);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </Provider>
  </QueryClientProvider>,
);

// reportWebVitals();